import LRU from 'lru-cache';

const cacheOptions = {
  max: 200, //The maximum size of the cache (amount of items), checked by applying the length function to all values in the cache.
  ttl: 1000 * 60 * 10, // Maximum age in ms (10 minutes now)
};

/**
 * A basic least-recently-used cache which we can re-use through the application to speed up things.
 * Keeps the last 200 used endpoints in memory for around 3 minutes.
 */
const cache = new LRU<string, any>(cacheOptions);

export default cache;
